import { useEffect, useRef, useState } from 'react'
import './trip-actions-menu.css'

export function TripActionsMenu({ label, onShare, onEdit }: { label: string; onShare: () => void; onEdit: () => void }) {
  const [open, setOpen] = useState(false)
  const menuRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!open) return
    const closeFromPointer = (event: PointerEvent) => {
      if (!menuRef.current?.contains(event.target as Node)) setOpen(false)
    }
    const closeFromKeyboard = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setOpen(false)
    }
    document.addEventListener('pointerdown', closeFromPointer)
    document.addEventListener('keydown', closeFromKeyboard)
    return () => {
      document.removeEventListener('pointerdown', closeFromPointer)
      document.removeEventListener('keydown', closeFromKeyboard)
    }
  }, [open])

  return (
    <div className="trip-actions-menu" ref={menuRef}>
      <button
        className="trip-actions-menu__trigger"
        type="button"
        aria-label={`Edit and share trip ${label}`}
        title="Edit and share trip"
        aria-expanded={open}
        aria-haspopup="menu"
        onClick={() => setOpen((current) => !current)}
      >
        <span aria-hidden="true">•••</span>
      </button>
      {open ? (
        <div className="trip-actions-menu__popover" role="menu">
          <button type="button" role="menuitem" aria-label={`Share ${label}`} title="Share this trip" onClick={() => { setOpen(false); onShare() }}><span aria-hidden="true">↗</span> Share</button>
          <button type="button" role="menuitem" aria-label={`Edit ${label}`} title="Edit this trip" onClick={() => { setOpen(false); onEdit() }}><span aria-hidden="true">✎</span> Edit</button>
        </div>
      ) : null}
    </div>
  )
}
